<div class="classification-comments" [dir]="dir">
    <div class="title">
        <div>{{'forms.common.Comments' | translate}}</div>
        <i class="fa fa-times pointer" (click)="close()"></i>
    </div>
    <div class="{{loading ? 'loader' : ''}}"></div>
    <div class="comments-list-container" (scroll)="onScroll($event)">

        <div *ngFor="let item of managersNotes; trackBy : trackByFn;let i = index" class="comment" [id]="item._id">
            <ng-container *ngIf="item.fromMe;else fromOther">
                <div class="message-container">
                    <div class="userAvatar"></div>
                    <div class="content">
                        <div class="message">{{item.message}}</div>
                        <div class="time">{{item.created | dateToTimeAgo}}</div>
                    </div>
                    <i class="fa fa-ellipsis-v pointer option" *ngIf="item.taskId == taskId && !loading && !editing"
                        [matMenuTriggerFor]="optionMenu" #menuTrigger="matMenuTrigger"></i>


                    <mat-menu #optionMenu="matMenu" yPosition="above">
                        <button mat-menu-item (click)="edit(item,$event)">
                            {{'forms.common.Edit' | translate}}
                            <i class="fa fa-edit"></i>
                        </button>
                        <button mat-menu-item (click)="delete(i,item,$event)">
                            {{'forms.common.delete' | translate}}
                            <i class="fa fa-trash"></i>
                        </button>
                    </mat-menu>
                </div>
            </ng-container>
            <ng-template #fromOther>
                <div class="message-container other">
                    <div class="content">
                        <div class="username">
                            {{item.name}}
                            <span *ngIf="item.roleByTask" class="role"> - ({{'forms.common.' + item.roleByTask |
                                translate}})</span>
                        </div>
                        <div class="message">{{item.message}}</div>
                        <div class="time">{{item.created | dateToTimeAgo}}</div>
                    </div>
                    <div class="userAvatar"></div>
                </div>
            </ng-template>
        </div>
    </div>

    <div class="action-container {{loading || (hasMessageFromSameTask && !editing ? 'disabledContainer' : '')}}"
        *ngIf="!data.options.disableComments">
        <!-- <input type="text" #messageElement [(ngModel)]="message"
            [disabled]="loading || (hasMessageFromSameTask && !editing)" (keyup.enter)="send()" /> -->

        <textarea class="resize-ta" #messageElement [(ngModel)]="message" (keyup.enter)="inputKeyup()"
            [disabled]="loading || (hasMessageFromSameTask && !editing)"></textarea>
        <div class="send" (click)="send()">
            <i class="fa fa-paper-plane"></i>
        </div>
    </div>
</div>